import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { actions } from "../../../store/actions/playerActions"
import styles from './Audio.module.css'

export const Audio = React.forwardRef((props, ref) => {
    const dispatch = useDispatch()

    useEffect(() => {
        return () => dispatch(actions.playerResetAC())
    }, [])

    useEffect(() => {
        let initialPlay = false
        ref.current.load()
        ref.current.oncanplay = () => {
            if (initialPlay) return
            initialPlay = true
            ref.current.currentTime = props.currentTime
        }
    }, [props.source])

    const onPlayHandler = () => {
        ref.current.autoplay = true
    }

    const onPauseHandler = () => {
        ref.current.autoplay = false
    }

    return <audio ref={ref} onPause={onPauseHandler} onPlay={onPlayHandler} className={styles.audio} controls>
        <source src={props.source} />
    </audio>
})